module.exports = __webpack_public_path__ + "fonts/Mukta-600-latin15.b7c8f5c.woff2";